import {Column} from 'react-table'
import {columnGenerators} from '../../../../../../_metronic/helpers'
export const header = (isFranchise = false) => [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'User Name',
    value: 'name',
  },
  {
    label: 'No of Transactions',
    value: 'totalValue',
  },
  {
    label: 'Material Inward',
    value: 'collectCount',
  },
  {
    label: 'Processing',
    value: 'productionCount',
  },
  {
    label: 'Dispatch',
    value: 'returnCount',
  },
]

// const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

// export {roleColumns}

const roleColumns = (isFranchise = false) => {
  return columnGenerators(header(isFranchise))
}
export {roleColumns}
